<template>
    <div>
        <v-container fluid pa-0 pb-5>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div style="display: flex; flex-direction: row; align-items: center">
                                {{$t('lang.language')}}:<b><span>&nbsp;</span>{{current_user.language_display ? current_user.language_display : current_user.language | capitalize }}</b>
                            </div>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-form ref="create_article">
                    <v-flex px-4 mt-4>
                        <v-layout row :wrap="$bp.smallScreen">
                            <v-flex :xs9="!$bp.xs" :xs12="$bp.smallScreen" :mr-3="!$bp.smallScreen">
                                <bc-autocomplete
                                    v-model="edit_mod"
                                    :items="modules"
                                    item-text="display_name"
                                    item-value="module"
                                    :label="$t('lang.select_a_module')"
                                    :rules="ifValid('english_article.module_id')"
                                    class="mt-0"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex :xs3="!$bp.xs" :xs12="$bp.smallScreen">
                                <v-btn color="success" class="elevation-0 ml-0 w-100 mb-0" @mouseup.left="$router.push({ name: 'help_articles_add' });">{{$t('lang.add_new_article')}}</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout row :wrap="$bp.smallScreen" class="mt-3">
                            <v-flex w-100 pt-0 :xs4="edit_article" :xs12="!edit_article || !$bp.lgAndUp" :mr-4="edit_article && !$bp.smallScreen">
                                <v-layout :row="$bp.lgAndUp" :column="!$bp.lgAndUp">
                                    <v-flex xs12 style="max-height: 65vh" w-100>
                                        <vue-perfect-scrollbar style="height: 100%; width: 100%">
                                            <v-flex w-100 v-for="(article, index) in current_articles" :key="index" class="clickable" mb-3 mt-2 @mouseup.left="dbGetArticleGroup(article.group_id)">
                                                <v-flex w-100>
                                                    <div style="display: flex; align-items: center; font-size: 1.1rem;"><b>{{ article.title }}</b></div>
                                                    <div class="mt-2" style="display: flex; align-items: center; font-size: 1rem;">{{ article.article | shrink_text(300) }}</div>
                                                    <v-divider style="width: 100%"></v-divider>
                                                </v-flex>
                                            </v-flex>
                                        </vue-perfect-scrollbar>
                                        <div
                                            style="width: 100%; height: 45vh; display: flex; justify-content: center; align-items: center; text-align: center;"
                                            class="grey--text"
                                            v-if="!edit_mod"
                                        >
                                            {{$t('lang.select_module')}}
                                        </div>
                                        <div
                                            style="width: 100%; height: 45vh; display: flex; justify-content: center; align-items: center; text-align: center;"
                                            class="grey--text"
                                            v-if="edit_mod && current_articles.length == 0"
                                        >
                                            {{$t('lang.no_articles_found') + edit_mod}}
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex
                                v-if="edit_article"
                                :mt-3="$bp.smallScreen"
                                :xs8="!$bp.smallScreen"
                                pa-4
                                :style="{'background-color': '#f5f5f5', 'border-radius': '5px;', 'max-height': $bp.xs ? '85vh' : '70vh', width: '100%'}"
                            >
                                <!-- ENGLISH ARTICLE -->
                                <vue-perfect-scrollbar>
                                    <v-form ref="createArticle" lazy-validation>
                                        <v-flex>
                                            <h3 class="headline mb-3 mt-0">{{$t('lang.english')}}</h3>
                                            <v-text-field
                                                v-model="english_article.title"
                                                :label="`${$t('lang.article_title')} *`"
                                                :counter="showCounter(english_article.title, 'english_article.title')"
                                                :rules="ifValid('english_article.title')"
                                            ></v-text-field>
                                            <v-textarea
                                                v-model="english_article.article"
                                                :label="`${$t('lang.write_article')} *`"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('english_article.article')"
                                            ></v-textarea>
                                        </v-flex>
                                        <!-- OTHER LANG ARTICLES -->
                                        <v-flex v-for="(article, index) in articles_to_edit" :key="index">
                                            <h3 class="headline mb-3 mt-0">{{article.language_display | capitalize}}</h3>
                                            <v-text-field
                                                v-model="articles_to_edit[index].title"
                                                :label="`${$t('lang.article_title')} *`"
                                                :counter="showCounter(articles_to_edit[index].title, 'english_article.title')"
                                                :rules="ifValid('english_article.title')"
                                            ></v-text-field>
                                            <v-textarea
                                                v-model="articles_to_edit[index].article"
                                                :label="`${$t('lang.write_article')} *`"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('english_article.article')"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                                <div :style="{display: 'flex', 'flex-direction': +!$bp.lgAndUp ? 'column' : 'row', width: '100%', 'padding-top': '10px'}">
                                    <v-btn color="success" :class="['elevation-0', 'ml-0', !$bp.lgAndUp ? 'mb-2' : 'mb-0', $bp.lgAndUp ? 'mr-2' : 'mr-0', 'mt-auto']" style="flex-grow: 1; height: 36px; max-height: 36px" @mouseup.left="dbUpdateArticles()">{{$t('lang.save_article')}}</v-btn>
                                    <v-btn color="error" :class="['elevation-0', 'ml-0', 'mb-0', 'mr-0', !$bp.lgAndUp ? 'mt-1' : 'mt-auto']" style="flex-grow: 1; height: 36px; max-height: 36px" @mouseup.left="removeArticleDialog = true">{{$t('lang.removeArticle')}}</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-form>
            </v-card>
            <!-- dialogs -->
             <v-dialog v-model="removeArticleDialog" persistent max-width="500">
                <v-card>
                <v-card-title>
                    <span class="headline">{{$t('lang.removeArticle')}}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="removeArticleDialog"
                        :dialog-status="removeArticleDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <p>{{$t('lang.confirm_remove_article')}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="removeArticleDialog = false">{{$t('lang.cancel')}}</v-btn>
                    <v-btn color="success" @mouseup.left="deleteArticle()">{{$t('lang.confirm')}}</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            removeArticleDialog: false,
            edit_article: false,
            current_article_id: null,
            language: null,
            edit_mod: this.$store.getters.currentRoute || null,
            current_articles: [],
            articles_to_edit: [],
            dbGetArticleGroup: _.debounce(this.getArticleGroup, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbUpdateArticles: _.debounce(this.updateArticles, 1500, { maxWait: 1500, leading: true, trailing: false }),
            english_article: {},
        };
    },
    watch: {
        edit_mod: {
            immediate: true,
            handler(newVal, oldVal) {
                this.getArticles(newVal, true);
                this.edit_article = false;
            },
        },
    },
    beforeRouteEnter(to, from, next) {
        if (store.getters.modules == null) {
            store
                .dispatch("fetchModules", {
                    url: "modules",
                    method: "get",
                    stateProperty: "modules",
                    commit: true,
                    localStorage: true,
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        next((vm) => {
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (store.getters.modules == null) {
            this.$store
                .dispatch("fetchModules", {
                    url: "modules",
                    method: "get",
                    stateProperty: "modules",
                    commit: true,
                    localStorage: true,
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    computed: {
        ...mapState({
            rules_english_article: (state) => state.validation.rules_english_article,
        }),
        ...mapGetters(["currentRoute", "modules"]),
    },
    methods: {
        getArticles(mod, boolean) {
            boolean ? this.startLoader() : null;

            this.$store
                .dispatch("fetchHelp", {
                    url: "help?module=" + mod + "&language=" + this.current_user.language,
                    method: "get",
                    stateProperty: "articles",
                })
                .then((data) => {
                    // only select the module they want
                    this.current_articles = data.help_articles;
                    boolean ? this.finishLoader() : null;
                });
        },
        getArticleGroup(group) {
            this.startLoader();

            this.$store
                .dispatch("fetchHelp", {
                    url: "help?group_id=" + group,
                    method: "get",
                    stateProperty: "articles",
                })
                .then((data) => {
                    this.articles_to_edit = data.help_articles.filter((article) => {
                        return article.language != "en";
                    });
                    let english_article = data.help_articles.filter((article) => {
                        return article.language == "en";
                    });
                    this.english_article = english_article[0];
                    this.edit_article = true;
                    this.current_article_id = group;
                    this.finishLoader();
                });
        },
        updateArticles(notification, id) {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("create_article")) {
                    let body = { help_articles: [] };

                    let english_article = {
                        help_id: this.english_article.help_id,
                        module_id: this.english_article.module_id,
                        title: this.english_article.title,
                        article: this.english_article.article,
                        language: this.english_article.language,
                    };

                    let article_in_other_langs = this.articles_to_edit.filter((article) => {
                        //removing all the stuff we don't want to send off
                        delete article.created_by;
                        delete article.date_created;
                        delete article.date_deleted;
                        delete article.date_modified;
                        delete article.display_name;
                        delete article.deleted_by;
                        delete article.group_id;
                        delete article.language_display;
                        delete article.links;
                        delete article.module;
                        delete article.status;
                        delete article.last_updated_by;

                        return article.language != "en";
                    });

                    body.help_articles.push(english_article);
                    article_in_other_langs.forEach((article) => {
                        body.help_articles.push(article);
                    });
                    this.startLoader(true);
                    this.$store
                        .dispatch("fetchHelp", {
                            url: "help",
                            method: "patch",
                            body,
                        })
                        .then(() => {
                            this.$store.commit("validationOff");
                            this.getArticles(this.edit_mod, false);
                            this.finishLoader();
                        });
                }
            });
        },
        deleteArticle() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchHelp", {
                    url: "help/" + this.current_article_id,
                    method: "delete",
                })
                .then(() => {
                    this.current_articles = this.current_articles.filter((article) => {
                        return article.group_id != this.current_article_id;
                    });
                    this.edit_article = false;
                    this.removeArticleDialog = false;
                    this.$store.commit("toggleModalLoader", false);
                });
        },
    },
};
</script>
